import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import cn from 'classnames'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import { onFormInputEnterPress } from 'helpers/input'

class EventResultTextInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      evt_logbook_id: props.eventInfo.evt_logbook_id,
      previousValue: props.eventInfo.previous_value,
      value: props.eventInfo.value,
      oldValue: props.eventInfo.value,
    }
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.eventInfo !== nextProps.eventInfo) {
      this.setState({
        evt_logbook_id: nextProps.eventInfo.evt_logbook_id,
        previousValue: nextProps.eventInfo.previous_value,
        value: nextProps.eventInfo.value,
        oldValue: nextProps.eventInfo.value,
      })

      return false
    }

    return true
  }

  onInputChange = e => {
    this.setState({
      value: e.target.value,
    })
  }

  setResultId = ({ id }) => {
    this.setState({
      evt_logbook_id: id,
    })
  }

  onAutoSaveValue = () => {
    const { onValueChange, eventInfo } = this.props
    const { value, oldValue, evt_logbook_id } = this.state
    const trmValue = typeof value === 'string' ? value.trim() : value

    if (!trmValue) {
      this.setState({
        value: typeof oldValue === 'string' ? oldValue.trim() : oldValue,
      })

      return
    }

    if (trmValue !== oldValue) {
      this.setState(
        {
          oldValue: trmValue,
        },
        () => {
          onValueChange({
            ...eventInfo,
            value: trmValue,
            evt_logbook_id,
            setResultId: this.setResultId,
          })
        },
      )
    }
  }

  render() {
    const { tabIndex, dataIndex, disabled } = this.props
    const { value, previousValue } = this.state
    const checkValue = !value ? '' : value
    const checkPreviousValue = !previousValue ? '' : previousValue

    return (
      <FormControl>
        <TextField
          value={checkValue}
          onChange={this.onInputChange}
          onBlur={this.onAutoSaveValue}
          autoFocus={dataIndex === 0}
          placeholder={String(checkPreviousValue)}
          inputProps={{
            onKeyUp: onFormInputEnterPress,
            tabIndex,
            className: cn({ 'js-enter-press-input': !disabled }),
            'data-index': dataIndex,
          }}
          className="event-result-field event-result-input"
          disabled={disabled}
        />
      </FormControl>
    )
  }
}

export default injectIntl(EventResultTextInput)
